import React, { useEffect } from "react";

import { css } from "@emotion/react";
import { ReactComponent as MagnifySvgIcon } from "../../../assets/icons/Icon/DKT/Magnify black.svg";
import { CSS_MQ } from "../../../styles/breakpoints";
import { ReticleTechSpecSection } from "@swo/storefront";
import { FONTS, fontSize } from "../../../styles/fonts";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { T } from "../../../components/T";

export function ReticleSection(props: ReticleTechSpecSection) {
  return (
    <div
      css={css`
        width: 100%;
        display: grid;
        grid-column-gap: 10px;
        grid-row-gap: 10px;
      `}
    >
      {props.attributes.map((reticle, idx) => {
        return (
          <div
            key={idx}
            css={reticleItemStyles}
            // className={reticle.notAvailable ? "not-available" : undefined}
          >
            {false /* Zoom feature not ready */ && (
              <MagnifySvgIcon
                css={css`
                  position: absolute;
                  right: 12px;
                  top: 12px;
                `}
              />
            )}
            <span
              css={[
                FONTS.SwarovskiFutura500,
                fontSize.x2,
                css`
                  margin-bottom: 5px;
                `,
              ]}
            >
              <T>{reticle.label}</T>
            </span>
            <img
              src={reticle.url}
              css={css`
                margin-bottom: 10px;

                ${CSS_MQ.atMostSm} {
                  max-width: 100%;
                  max-height: 100%;
                }

                ${CSS_MQ.atLeastMd} {
                  max-width: 100%;
                  max-height: 200px;
                }
              `}
            />
          </div>
        );
      })}
    </div>
  );
}

const reticleItemStyles = css`
  position: relative;
  align-self: flex-start;

  display: grid;
  grid-template-rows: auto 65px;
  ${CSS_MQ.atLeastMd} {
    grid-template-rows: auto 85px;
  }
  grid-template-columns: 1fr;
  justify-items: center;

  &.not-available {
    filter: opacity(0.2);
    display: none;
  }

  padding: 16px 20px 18px;
  ${CSS_MQ.atLeastMd} {
    padding: 26px 20px 24px;
  }
  background: white;

  border-radius: 8px;
  border: 2px solid ${CSS_COLORS.Grey6};

  text-decoration: none;
  color: inherit;
`;
